// 所有请求的封装
// bath对象：所有接口
// i8n：国际化
// $ajax:所有需要token的接口
// loginAxios:登录、获取平台方信息、等不需要token的接口
import axios from 'axios';
import ElementUI from 'element-ui';
import i18n from '../lang/i18n'

//普通操作请求 (需要token)
const $ajax = axios.create({
    // timeout: 15000
});

//登录操作请求 (不需要token)
const loginAxios = axios.create({
    timeout: 15000
});

const bath = {
    qiniuUploadToken: '/api/dilu-user/qiniu/qiniuUploadToken.action',//获取七牛云token等
    uploadQiniu: 'https://upload.qiniup.com/', //上传七牛
    getInfoByDomain: '/api/dilu-admin/operate/platformManagement/platform/getInfoByDomain', //获取平台方信息
    randomImage: '/api/dilu-admin/system/randomImage', //获取验证码
    login: '/api/dilu-admin/system/login', // 用户登录
    getVerificationCode: '/api/dilu-admin/system/getVerificationCode', //忘记密码获取验证码
    checkVerificationCode: '/api/dilu-admin/system/checkVerificationCode', // 忘记密码-验证验证码
    resetSysUserPasswordByMail: '/api/dilu-admin/system/resetSysUserPasswordByMail', //忘记密码-根据邮箱地址重设密码
    resetSelfPassword: '/api/dilu-admin/system/resetSelfPassword.action', //修改密码
    logout: '/api/dilu-admin/system/logout.action', //web后台退出登录
    switchRegion: "/api/dilu-admin/system/region/switch.action", //区域切换

    admList: '/api/dilu-report/system/operationLog/admList.action', //管理后台操作日志记录
    apiAdd: '/api/dilu-report/system/operationLog/apiAdd.action', //添加日志类别
    apiDelete: '/api/dilu-report/system/operationLog/apiDelete.action', //删除日志类别
    apiEdit: '/api/dilu-report/system/operationLog/apiEdit.action', //修改日志类别
    apiList: '/api/dilu-report/system/operationLog/apiList.action', //日志类别查询

    listWithButtons: '/api/dilu-admin/system/platformPermissions/menuManagement/listWithButtons.action', //查询所有菜单带按钮
    menuManagementAdd: '/api/dilu-admin/system/platformPermissions/menuManagement/add.action', //新增菜单
    menuManagementDelete: '/api/dilu-admin/system/platformPermissions/menuManagement/delete.action', //删除菜单
    menuManagementEdit: '/api/dilu-admin/system/platformPermissions/menuManagement/edit.action',//编辑菜单
    menuManagementAddButton: '/api/dilu-admin/system/platformPermissions/menuManagement/addButton.action', //新增按钮
    menuManagementEditButton: '/api/dilu-admin/system/platformPermissions/menuManagement/editButton.action', //编辑按钮
    menuManagementDeleteButton: '/api/dilu-admin/system/platformPermissions/menuManagement/deleteButton.action', //删除按钮

    roleManagementList: '/api/dilu-admin/system/platformPermissions/roleManagement/list.action', //角色管理-列表（分页）
    roleManagementListAll: '/api/dilu-admin/system/platformPermissions/roleManagement/listAll.action',//角色管理-查询所有角色   
    roleManagementAdd: '/api/dilu-admin/system/platformPermissions/roleManagement/add.action', //新增角色
    roleManagementDelete: '/api/dilu-admin/system/platformPermissions/roleManagement/delete.action', //角色管理删除角色
    roleManagementInfo: '/api/dilu-admin/system/platformPermissions/roleManagement/info.action', //角色管理-根据id查询菜单按钮权限
    roleManagementEdit: '/api/dilu-admin/system/platformPermissions/roleManagement/edit.action', //角色管理-编辑

    departmentManagementListAll: '/api/dilu-admin/system/platformPermissions/departmentManagement/listAll.action', //部门管理-查询所有部门
    departmentManagementInfo: '/api/dilu-admin/system/platformPermissions/departmentManagement/info.action', // 部门管理-根据id查询
    departmentManagementDelete: '/api/dilu-admin/system/platformPermissions/departmentManagement/delete.action',// 部门管理-删除部门
    departmentManagementAdd: '/api/dilu-admin/system/platformPermissions/departmentManagement/add.action', //部门管理-新增部门

    accountManagementList: '/api/dilu-admin/system/platformPermissions/accountManagement/list.action', // 账号管理-列表（分页）
    accountManagementAdd: '/api/dilu-admin/system/platformPermissions/accountManagement/add.action', //账号管理-新增
    accountManagementEdit: '/api/dilu-admin/system/platformPermissions/accountManagement/edit.action', //账号管理-编辑
    accountManagementDelete: '/api/dilu-admin/system/platformPermissions/accountManagement/delete.action', // 账号管理-删除
    accountManagementResetPassword: '/api/dilu-admin/system/platformPermissions/accountManagement/resetPassword.action',// 账号管理-重置密码
    accountManagementShare: '/api/dilu-admin/system/platformPermissions/accountManagement/share.action', //账号管理-一键分享
    accountManagementInfo: '/api/dilu-admin/system/platformPermissions/accountManagement/info.action', // 账号管理，根据id查详情

    appAdvertisingList: '/api/dilu-serve/system/basicConfiguration/appAdvertising/list.action', //app广告-列表（分页）
    appAdvertisingGetFunctionCode: '/api/dilu-serve/system/basicConfiguration/appAdvertising/getFunctionCode.action', //app广告-查出所有应用路径
    appAdvertisingAdd: '/api/dilu-serve/system/basicConfiguration/appAdvertising/add.action', //app广告-新增
    appAdvertisingDelete: '/api/dilu-serve/system/basicConfiguration/appAdvertising/delete.action', //app广告-删除
    appAdvertisingEdit: '/api/dilu-serve/system/basicConfiguration/appAdvertising/edit.action', //app广告-编辑

    versionManagementList: '/api/dilu-serve/system/appVersion/versionManagement/list.action', // APP版本-分页列表查询
    versionManagementSave: '/api/dilu-serve/system/appVersion/versionManagement/save.action',// APP版本-新增
    versionManagementDelete: '/api/dilu-serve/system/appVersion/versionManagement/delete.action', //APP版本-批量删除
    versionManagementUpdate: '/api/dilu-serve/system/appVersion/versionManagement/update.action', //APP版本-修改
    versionReviewReviewList: '/api/dilu-serve/system/appVersion/versionReview/reviewList.action', //查询所有待审核app版本
    versionReviewReview: '/api/dilu-serve/system/appVersion/versionReview/review.action', // APP版本审核

    bikeCategoryListAll: '/api/dilu-device/bikeCategory/listAll.action', //车辆类别-查询所有
    platformAdd: '/api/dilu-admin/operate/platformManagement/platform/add.action', //平台方管理-新增
    platformInfoById: '/api/dilu-admin/operate/platformManagement/platform/infoById.action', //平台方管理-根据id查询
    platformEdit: '/api/dilu-admin/operate/platformManagement/platform/edit.action', //平台方管理-编辑
    platformDelete: '/api/dilu-admin/operate/platformManagement/platform/delete.action', // 平台方管理-删除 {id}.action
    platformResetPlatformAdminPassword: '/api/dilu-admin/operate/platformManagement/platform/resetPlatformAdminPassword.action', //平台方-重置密码
    platformSharePlatformInfo: '/api/dilu-admin/operate/platformManagement/platform/sharePlatformInfo.action',//平台方-一键分享  
    platformList: '/api/dilu-admin/operate/platformManagement/platform/list.action', //平台方管理-列表（分页）
    getAppCodes: '/api/dilu-admin/appCode/getAppCodes.action', //获取appcode

    appAgreementList: '/api/dilu-serve/system/basicConfiguration/appAgreement/list.action',// app协议-列表（分页）
    appAgreementGetFunctionCode: '/api/dilu-serve/system/basicConfiguration/appAgreement/getFunctionCode.action',//app协议-查出所有协议的应用路径
    appAgreementAdd: '/api/dilu-serve/system/basicConfiguration/appAgreement/add.action', //app协议-新增
    appAgreementDelete: '/api/dilu-serve/system/basicConfiguration/appAgreement/delete.action', //app协议-删除
    appAgreementEdit: '/api/dilu-serve/system/basicConfiguration/appAgreement/edit.action', //app协议-编辑

    userList: '/api/dilu-user/user/userCenter/userList/list.action', //app用户管理-列表（分页）
    userListInfo: '/api/dilu-user/user/userCenter/userList/info/{id}.action', //app用户管理-查看详情
    userListDelete: '/api/dilu-user/user/userCenter/userList/delete.action', //app用户管理-删除,
    getBindBikeByUserId: '/api/dilu-riding/user/userCenter/userList/getBindBikeByUserId.action', //app用户管理-根据用户id查询旗下所有绑定车辆
    getTrackDataByAppUserId: '/api/dilu-riding/user/userCenter/userList/getTrackDataByAppUserId.action',  //根据用户id查询骑行记录带轨迹（分页）
    verifyList: '/api/dilu-user/user/userCenter/verifyCode/list.action', //用户验证码-列表（分页）
    userRefresh:'/api/dilu-user/user/userCenter/userList/refresh.action', //刷新用户信息

    feedbackList: '/api/dilu-serve/user/userCenter/feedback/list.action', //意见反馈-列表（分页）
    feedbackTextSee: '/api/dilu-serve/user/userCenter/feedback/info/{id}.action', //意见反馈-查看详情
    feedbackExport: '/api/dilu-serve/app/export.action', //意见反馈-导出
    equipmentModeList: '/api/dilu-device/equipment/deviceManagement/equipmentMode/list.action', //车辆型号-列表（分页）
    equipmentModeGetBelongCategoryId: '/api/dilu-device/equipment/deviceManagement/equipmentMode/info/{id}.action', //车辆型号-根据id查询
    equipmentModeAdd: '/api/dilu-device/equipment/deviceManagement/equipmentMode/add.action', //车辆型号-新增
    equipmentModeListAll: '/api/dilu-device/equipment/deviceManagement/equipmentMode/listAll.action', //车辆型号-查询所有
    equipmentModeDelete: '/api/dilu-device/equipment/deviceManagement/equipmentMode/delete.action', //车辆型号-删除
    equipmentModeEdit: '/api/dilu-device/equipment/deviceManagement/equipmentMode/edit.action', //车辆型号-编辑

    equipmentList: '/api/dilu-device/equipment/deviceManagement/equipmentList/list.action', //车辆列表-列表（分页）
    equipmentListCompile: '/api/dilu-device/equipment/deviceManagement/equipmentList/compile.action', //车辆列表-编辑
    equipmentInfo: '/api/dilu-device/equipment/deviceManagement/equipmentList/info.action', //车辆列表-根据id查询
    equipmentListAdd: '/api/dilu-device/equipment/deviceManagement/equipmentList/add.action', //车辆列表-导入车辆-新增或更新
    equipmentListDelete: '/api/dilu-device/equipment/deviceManagement/equipmentList/delete.action', //车辆列表-删除
    equipmentListEdit: '/api/dilu-device/equipment/deviceManagement/equipmentList/edit.action', //车辆列表-更换车辆其他信息
    equipmentListExportExcel: '/api/dilu-device/equipment/deviceManagement/equipmentList/exportExcel.action', //车辆列表-导出
    equipmentListGetBikeController: '/api/dilu-device/equipment/deviceManagement/equipmentList/getBikeController.action', //车辆列表-查询车辆的实时状态
    equipmentListUpdateByBatchId: '/api/dilu-device/equipment/deviceManagement/equipmentList/updateByBatchId.action', //车辆列表-根据批次号更新
    equipmentListUpdateByBikeCode: '/api/dilu-device/equipment/deviceManagement/equipmentList/updateByBikeCode.action', //车辆列表-批量更换
    findAllBatchId: '/api/dilu-device/equipment/deviceManagement/equipmentList/updateByBatchId/findAllBatchId.action', //车辆列表-根据批次号更新-批次ID下拉框
    findAllBikeTypeName: '/api/dilu-device/equipment/deviceManagement/equipmentList/updateByBatchId/findAllBikeTypeName.action', //车辆列表-根据批次号更新-新车辆型号下拉框
    unbindUserAndBike: '/api/dilu-riding/equipment/deviceManagement/equipmentList/unbindUserAndBike.action',//车辆列表-根据车辆编码解绑当前绑定的主用户
    getBindInfoByBikeCode: '/api/dilu-riding/equipment/deviceManagement/equipmentList/getBindInfoByBikeCode.action',// 车辆列表-根据车辆编码查询绑定记录
    getLockRecordByBikeCode: '/api/dilu-riding/equipment/deviceManagement/equipmentList/getLockRecordByBikeCode.action',//车辆列表-根据车辆编码查询开关锁记录
    getBikeDataAnalysis: '/api/dilu-report/bikeDataAnalysis/getBikeDataAnalysis.action', //车辆列表-根据车辆id返回数据分析结果
    equipmentListGetAddInfo: '/api/dilu-device/equipment/deviceManagement/equipmentList/getAddInfo.action', //根据流水号查询导入进度
    updateFingerMac: '/api/dilu-device/equipment/deviceManagement/equipmentList/updateFingerMac.action', //根据车辆编码更新指纹锁蓝牙地址

    listAllFwVersion: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listAllFwVersion.action', //固件管理-查询所有适配的固件名称
    firmwareManagementList: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/list.action', //固件管理-列表（分页）
    firmwareManagementListAllBikeType: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listAllBikeType.action', //固件管理-查询所有车辆型号（筛选）
    firmwareManagementListAllCategory: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listAllCategory.action', //固件管理-查询所有车辆类别
    firmwareManagementListAll: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listAll.action', //固件管理-查询所有硬件版本
    firmwareManagementAdd: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/add.action', //固件管理-新增
    firmwareManagementDelete: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/delete.action', //固件管理-删除
    firmwareManagementEdit: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/edit.action', //固件管理-编辑
    firmwareManagementDisable: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/disable.action', //固件管理-禁用
    firmwareManagementListAllSuitableHwVersion: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listAllSuitableHwVersion.action', //固件管理-查询所有适配的硬件版本
    listALlDistinctHwVersion: '/api/dilu-device/equipment/firmwareUpdate/firmwareManagement/listALlDistinctHwVersion.action', //灰度配置-查询硬件版本
    importDevicetemplate: 'https://res-dilu.deebike.com/template202604.xlsx', //导入车辆模板
    importMasterplate: 'https://res-dilu.deebike.com/changetype20220224.xlsx', //下载批量更换型号模板
    langTemplate: 'https://res-dilu.deebike.com/lang2026012001.xlsx', //多语言导入模版下载
    getFailInfo:'/api/dilu-device/equipment/deviceManagement/equipmentList/getFailInfo.action', //下载错误报告

    grayScaleTestList: '/api/dilu-device/equipment/firmwareUpdate/grayScaleTest/list.action', //灰度测试-任务列表（分页）
    grayScaleTestAdd: '/api/dilu-device/equipment/firmwareUpdate/grayScaleTest/add.action', //灰度测试-灰度配置
    grayScaleTestInfo: '/api/dilu-device/equipment/firmwareUpdate/grayScaleTest/info.action', //灰度测试-任务详情 根据id查询
    grayScaleTestCancelGrayTask: '/api/dilu-device/equipment/firmwareUpdate/grayScaleTest/cancelGrayTask.action',  //灰度测试，取消灰度测试

    UpgradeTaskList: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/list.action', //正式升级任务-任务列表（分页）
    UpgradeTaskAdd: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/add.action', //正式升级任务-发布任务
    UpgradeTaskDelete: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/delete.action', //正式升级任务-撤回
    UpgradeListInfo: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/upgradeListInfo.action', //升级任务-任务升级详情

    UpgradeTaskExportBluetoothTaskInfo: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/exportBluetoothTaskInfo.action', //正式升级任务-导出任务详情
    UpgradeTaskInfo: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/info.action', //正式升级任务-任务详情 根据id查询
    UpgradeTaskRequestDeviceUpgrade: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/requestDeviceUpgrade.action', //上传App查询到的硬件信息并查询是否能升级
    UpgradeTaskRestart: '/api/dilu-device/equipment/firmwareUpdate/UpgradeTask/restart.action', //再次启动升级任务

    getDataStatistics: '/api/dilu-report/dataStatistics/getDataStatistics.action', //统计-数据统计
    bikeLocationData: '/api/dilu-report/dataStatistics/bikeLocationData.action', //查询车辆的坐标图表
    platformLocationData: '/api/dilu-report/dataStatistics/platformLocationData.action', //客户地域分布
    platformBikeData: '/api/dilu-report/dataStatistics/platformBikeData.action',//查询平台车辆数据饼图
    getUserTotal: '/api/dilu-report/dataStatistics/getUserTotal.action', //累计用户统计数据分析图
    getCreateUserTotal: '/api/dilu-report/dataStatistics/getCreateUserTotal.action', //查询平台方的新增用户注册图表信息
    getRidingMileage: '/api/dilu-report/dataStatistics/getRidingMileage.action', // 骑行里程统计图
    getRidingActiveCycling: '/api/dilu-report/dataStatistics/getRidingActiveCycling.action', //骑行活跃度统计图
    appUserRegisterData: '/api/dilu-report/dataStatistics/appUserRegisterData.action', //平台方新增用户

    platformListAll: '/api/dilu-admin/operate/platformManagement/platform/listAllPlatform.action', //查询平台方列表
    appLogList: '/api/dilu-report/system/operationLog/appList.action', //APP用户操作日志记录
    queryAppRequestUrl: '/api/dilu-report/system/operationLog/queryAppRequestUrl.action', //快捷搜索-根据条件查询app接口

    queryList: '/api/dilu-iot/iot/queryList.action', //在线设备列表查询
    devInfo: '/api/dilu-iot/iot/devInfo.action', //查看设备详情信息
    cmdSend: '/api/dilu-iot/iot/cmdSend.action',//下发指令
    cmdList: '/api/dilu-iot/iot/queryCmd.action',//IOT报文指令列表

    geoList: '/api/dilu-riding/geo/list.action', //查询电子围栏列表
    geoAddFence: '/api/dilu-riding/geo/addFence.action', //添加电子围栏
    geoDelFence: '/api/dilu-riding/geo/delFence.action',// 删除电子围栏
    geoEditFence: '/api/dilu-riding/geo/editFence.action', //修改电子围栏
    geoIotData: '/api/dilu-riding/geo/iotData.action', //获取车辆实时数据
    geoClearData: '/api/dilu-riding/geo/clearData.action', //清空车辆实时数据
    iotQueryList: '/api/dilu-iot/iot/queryRidingBikeList.action',// 查询在线设备列表
    listGeoInBike: '/api/dilu-riding/geo/manageVehicle/listGeoInBike.action', //管理车辆-车辆列表
    relationBike: '/api/dilu-riding/geo/manageVehicle/relationBike.action', //管理车辆-关联车辆
    disassociateBike: '/api/dilu-riding/geo/manageVehicle/disassociateBike.action', //关联车辆-取消关联车辆
    listRidingGeoFence:'/api/dilu-riding/geo/listRidingGeoFence.action', //查询全部电子围栏列表

    networkList:'/api/dilu-serve/afterSales/serviceStationManagement/serviceStationList/queryList.action', //服务网点管理-分页展示
    networkAdd:'/api/dilu-serve/afterSales/serviceStationManagement/serviceStationList/add.action', //新增网点
    networkEdit:'/api/dilu-serve/afterSales/serviceStationManagement/serviceStationList/edit.action', //编辑网点
    networkDelete:'/api/dilu-serve/afterSales/serviceStationManagement/serviceStationList/delete.action', //删除网点
    simcardList: '/api/dilu-serve/simcard/queryList.action',//查询SIM卡列表
    summaryInfo: '/api/dilu-serve/simcard/summaryInfo.action',//SIM卡摘要信息

    protocolList:'/api/dilu-serve/protocol/queryList.action', //通讯协议列表
    protocolEdit:'/api/dilu-serve/protocol/edit.action',      //新增通讯协议
    protocolDelete:'/api/dilu-serve/protocol/delete.action',  //删除通讯协议
    codeList:'/api/dilu-serve/protocol/codeList.action',      //获取错误代码列表
    errCodeEdit:'/api/dilu-serve/protocol/codeEdit.action',   //错误代码编辑
    errorLang:'/api/dilu-serve/protocol/errorLang.action',    //获取错误代码多语言定义
    langEdit:'/api/dilu-serve/protocol/langEdit.action',      //提交错误代码多语言定义
    errCodeDelete:'/api/dilu-serve/protocol/codeDel.action',  //删除错误代码
    faultBikeList:'/api/dilu-serve/fault/queryList.action',   //车辆故障列表 
    workOrderList:'/api/dilu-serve/workorder/queryList.action', //工单列表查询 
    workChatList:'/api/dilu-serve/workorder/chatList.action',   //工单交流记录 
    replyChat:'/api/dilu-serve/workorder/sendChat.action',      //回复客户工单 
    langImport:'/api/dilu-serve/protocol/langImport.action',    //多语言导入上传
    getProtocol:'/api/dilu-device/equipment/deviceManagement/equipmentMode/getProtocol.action'
}

//多语言导入上传
export const langImport = (params) => {
    return $ajax.post(`${bath.langImport}`, params).then(res => res.data)
}

//多语言导入模版下载
export const langTemplate = (params) => {
    return exportMethod(`${bath.langTemplate}`,params,"故障码多语言定义","xlsx").then(res => res.data);
}


//获取故障协议列表
export const getProtocol = (params) => {
    return $ajax.post(`${bath.getProtocol}`, params).then(res => res.data)
}

//回复客户工单
export const replyChat = (params) => {
    return $ajax.post(`${bath.replyChat}`, params).then(res => res.data)
}

//工单交流记录
export const workChatList = (params) => {
    return $ajax.post(`${bath.workChatList}`, params).then(res => res.data)
}

//工单列表查询
export const workOrderList = (params) => {
    return $ajax.post(`${bath.workOrderList}`, params).then(res => res.data)
}

//车辆故障列表
export const faultBikeList = (params) => {
    return $ajax.post(`${bath.faultBikeList}`, params).then(res => res.data)
}

//提交错误代码多语言定义
export const langEdit = (params) => {
    return $ajax.post(`${bath.langEdit}`, params).then(res => res.data)
}


/**
 * 获取错误代码多语言定义
 */
export const errorLang = (params) => {
    return $ajax.post(`${bath.errorLang}`, params).then(res => res.data)
}


/**
 * 下载二维码
 */
export const exportQrcode = (url, name) => {
    return exportQrcodeMethod(`${url}`, name).then(res => res.data)
}


/**
 * 获取平台方信息
 */
export const getInfoByDomain = (params) => {
    return axios.get(`${bath.getInfoByDomain}?domain=${params}`).then(res => res.data)
}


/**
 * 获取七牛云token等
 */
export const qiniuUploadToken = () => {
    return $ajax.get(`${bath.qiniuUploadToken}`).then(res => res.data)
}


/**
 * 上传七牛
 */
export const uploadQiniu = (params) => {
    return $ajax.post(`${bath.uploadQiniu}`, params).then((res) => res.data)
}



/**
 * 获取验证码
 */
export const randomImage = (params) => {
    return loginAxios.post(`${bath.randomImage}`,params).then(res => res.data)
}

/**
 * 登录
 */
export const login = (params) => {
    return loginAxios.post(`${bath.login}`, params).then(res => res.data)
}

/**
 * web后台退出登录
 */
export const logout = () => {
    return $ajax.post(`${bath.logout}`).then(res => res.data)
}



/**
 * 忘记密码获取验证码
 */
export const getVerificationCode = (params) => {
    return loginAxios.get(`${bath.getVerificationCode}${params}`).then(res => res.data)
}


/**
 * 忘记密码-验证验证码
 */
export const checkVerificationCode = (params) => {
    return loginAxios.get(`${bath.checkVerificationCode}${params}`).then(res => res.data)
}

/**
 * 忘记密码-根据邮箱地址重设密码
 */
export const resetSysUserPasswordByMail = (params) => {
    return loginAxios.post(`${bath.resetSysUserPasswordByMail}`, params).then(res => res.data)
}

/**
 * 修改密码
 */
export const resetSelfPassword = (params) => {
    return $ajax.post(`${bath.resetSelfPassword}`, params).then(res => res.data)
}

/**
 * 查询所有菜单带按钮
 */
export const listWithButtons = (params) => {
    if (params) {
        return $ajax.get(`${bath.listWithButtons}?${params}`).then(res => res.data)
    } else {
        return $ajax.get(`${bath.listWithButtons}`).then(res => res.data)
    }

}

/**
 * 新增菜单
 */
export const menuManagementAdd = (params) => {
    return $ajax.post(`${bath.menuManagementAdd}`, params).then(res => res.data)
}


/**
 * 区域切换
 */
export const switchRegion = (params) => {
    return $ajax.post(`${bath.switchRegion}`, params).then(res => res.data)
}



/**
 * 菜单管理删除菜单
 */
export const menuManagementDelete = (params) => {
    return $ajax.delete(`${bath.menuManagementDelete}${params}`).then(res => res.data)
}

/**
 * 编辑菜单
 */
export const menuManagementEdit = (params) => {
    return $ajax.post(`${bath.menuManagementEdit}`, params).then(res => res.data)
}


/**
 * 新增按钮
 */
export const menuManagementAddButton = (params) => {
    return $ajax.post(`${bath.menuManagementAddButton}`, params).then(res => res.data)
}

/**
 * 编辑按钮
 */
export const menuManagementEditButton = (params) => {
    return $ajax.post(`${bath.menuManagementEditButton}`, params).then(res => res.data)
}

/**
 * 删除按钮
 */
export const menuManagementDeleteButton = (params) => {
    return $ajax.delete(`${bath.menuManagementDeleteButton}${params}`).then(res => res.data)
}

/**
 * 角色管理-列表（分页）
 */
export const roleManagementList = (params) => {
    return $ajax.post(`${bath.roleManagementList}`, params).then(res => res.data)
}


/**
 * 角色管理-查询所有角色
 */
export const roleManagementListAll = () => {
    return $ajax.get(`${bath.roleManagementListAll}`).then(res => res.data)
}


/**
 * 新增角色
 */
export const roleManagementAdd = (params) => {
    return $ajax.post(`${bath.roleManagementAdd}`, params).then(res => res.data)
}


/**
 * 角色管理删除角色
 */
export const roleManagementDelete = (params) => {
    return $ajax.delete(`${bath.roleManagementDelete}${params}`).then(res => res.data)
}

/**
 * 角色管理-根据id查询菜单按钮权限
 */
export const roleManagementInfo = (params) => {
    return $ajax.get(`${bath.roleManagementInfo}${params}`).then(res => res.data)
}

/**
 * 角色管理-编辑
 */
export const roleManagementEdit = (params) => {
    return $ajax.post(`${bath.roleManagementEdit}`, params).then(res => res.data)
}


/**
 * 部门管理-查询所有部门
 */
export const departmentManagementListAll = () => {
    return $ajax.get(`${bath.departmentManagementListAll}`).then(res => res.data)
}


/**
 * 部门管理-根据id查询
 */
export const departmentManagementInfo = (params) => {
    return $ajax.get(`${bath.departmentManagementInfo}${params}`).then(res => res.data)
}



/**
 * 部门管理-删除部门
 */
export const departmentManagementDelete = (params) => {
    return $ajax.post(`${bath.departmentManagementDelete}`, params).then(res => res.data)
}

/**
 * 部门管理-新增部门
 */
export const departmentManagementAdd = (params) => {
    return $ajax.post(`${bath.departmentManagementAdd}`, params).then(res => res.data)
}

/**
 * 账号管理-列表（分页）
 */
export const accountManagementList = (params) => {
    return $ajax.post(`${bath.accountManagementList}`, params).then(res => res.data)
}


/**
 * 账号管理-新增
 */
export const accountManagementAdd = (params) => {
    return $ajax.post(`${bath.accountManagementAdd}`, params).then(res => res.data)
}

/**
 * 账号管理-编辑
 */
export const accountManagementEdit = (params) => {
    return $ajax.post(`${bath.accountManagementEdit}`, params).then(res => res.data)
}


/**
 * 账号管理-删除
 */
export const accountManagementDelete = (params) => {
    return $ajax.delete(`${bath.accountManagementDelete}?id=${params}`).then(res => res.data)
}


/**
 * 账号管理-重置密码
 */
export const accountManagementResetPassword = (params) => {
    return $ajax.post(`${bath.accountManagementResetPassword}`, params).then(res => res.data)
}


/**
 * 账号管理-一键分享
 */
export const accountManagementShare = (params) => {
    return $ajax.get(`${bath.accountManagementShare}?id=${params}`).then(res => res.data)
}

/**
 * 账号管理，根据id查详情
 */
export const accountManagementInfo = (params) => {
    return $ajax.get(`${bath.accountManagementInfo}?id=${params}`).then(res => res.data)
}


/**
 * app广告-列表（分页）
 */
export const appAdvertisingList = (params) => {
    return $ajax.post(`${bath.appAdvertisingList}`, params).then(res => res.data)
}


/**
 * app广告-查出所有应用路径
 */
export const appAdvertisingGetFunctionCode = (params) => {
    return $ajax.post(`${bath.appAdvertisingGetFunctionCode}`, params).then(res => res.data)
}

/**
 * app广告-新增
 */
export const appAdvertisingAdd = (params) => {
    return $ajax.post(`${bath.appAdvertisingAdd}`, params).then(res => res.data)
}


/**
 * app广告-删除
 */
export const appAdvertisingDelete = (params) => {
    return $ajax.post(`${bath.appAdvertisingDelete}`, params).then(res => res.data)
}

/**
 * app广告-编辑
 */
export const appAdvertisingEdit = (params) => {
    return $ajax.post(`${bath.appAdvertisingEdit}`, params).then(res => res.data)
}


/**
 * app协议-列表（分页）
 */
export const appAgreementList = (params) => {
    return $ajax.post(`${bath.appAgreementList}`, params).then(res => res.data)
}

/**
 * app协议-查出所有协议的应用路径
 */
export const appAgreementGetFunctionCode = (params) => {
    return $ajax.post(`${bath.appAgreementGetFunctionCode}`, params).then(res => res.data)
}

/**
 * app协议-新增
 */
export const appAgreementAdd = (params) => {
    return $ajax.post(`${bath.appAgreementAdd}`, params).then(res => res.data)
}

/**
 * app协议-删除
 */
export const appAgreementDelete = (params) => {
    return $ajax.post(`${bath.appAgreementDelete}`, params).then(res => res.data)
}


/**
 * app协议-编辑
 */
export const appAgreementEdit = (params) => {
    return $ajax.post(`${bath.appAgreementEdit}`, params).then(res => res.data)
}


/**
 * APP版本-分页列表查询
 */
export const versionManagementList = (params) => {
    return $ajax.post(`${bath.versionManagementList}`, params).then(res => res.data)
}


/**
 * APP版本-批量删除
 */
export const versionManagementDelete = (params) => {
    return $ajax.post(`${bath.versionManagementDelete}`, params).then(res => res.data)
}


/**
 * APP版本-新增
 */
export const versionManagementSave = (params) => {
    return $ajax.post(`${bath.versionManagementSave}`, params).then(res => res.data)
}


/**
 * APP版本-修改
 */
export const versionManagementUpdate = (params) => {
    return $ajax.post(`${bath.versionManagementUpdate}`, params).then(res => res.data)
}


/**
 * 查询所有待审核app版本
 */
export const versionReviewReviewList = (params) => {
    return $ajax.post(`${bath.versionReviewReviewList}`, params).then(res => res.data)
}


/**
 *  审核
 */
export const versionReviewReview = (params) => {
    return $ajax.post(`${bath.versionReviewReview}`, params).then(res => res.data)
}




/**
 * 获取appcode
 */
export const getAppCodes = () => {
    return $ajax.get(`${bath.getAppCodes}`).then(res => res.data)
}


/**
 * 车辆类别-查询所有
 */
export const bikeCategoryListAll = () => {
    return $ajax.get(`${bath.bikeCategoryListAll}`).then(res => res.data)
}


/**
 * 平台方管理-列表（分页）
 */
 export const platformList = (params) => {
    return $ajax.post(`${bath.platformList}`, params).then(res => res.data)
}



/**
 * 平台方管理-新增
 */
export const platformAdd = (params) => {
    return $ajax.post(`${bath.platformAdd}`, params).then(res => res.data)
}

/**
 * 平台方管理-根据id查询
 */
export const platformInfoById = (params) => {
    return $ajax.post(`${bath.platformInfoById}?id=${params}`).then(res => res.data)
}

/**
 * 平台方管理-编辑
 */
export const platformEdit = (params) => {
    return $ajax.post(`${bath.platformEdit}`, params).then(res => res.data)
}



/**
 * 平台方管理-删除 {id}.action
 */
export const platformDelete = (params) => {
    return $ajax.delete(`${bath.platformDelete}?id=${params}`).then(res => res.data)
}


/**
 * 平台方-重置密码
 */
export const platformResetPlatformAdminPassword = (params) => {
    return $ajax.post(`${bath.platformResetPlatformAdminPassword}`, params).then(res => res.data)
}



/**
 * 平台方-一键分享 
 */
export const platformSharePlatformInfo = (params) => {
    return $ajax.get(`${bath.platformSharePlatformInfo}?platformId=${params}`).then(res => res.data)
}


/**
 * 管理后台操作日志记录
 */
export const admList = (params) => {
    return $ajax.post(`${bath.admList}`, params).then(res => res.data)
}

/**
 * 添加日志类别
 */
export const apiAdd = (params) => {
    return $ajax.post(`${bath.apiAdd}`, params).then(res => res.data)
}

/**
 * 删除日志类别
 */
export const apiDelete = (params) => {
    return $ajax.post(`${bath.apiDelete}`, params).then(res => res.data)
}

/**
 * 修改日志类别
 */
export const apiEdit = (params) => {
    return $ajax.post(`${bath.apiEdit}`, params).then(res => res.data)
}

/**
 * 日志类别查询
 */
export const apiList = (params) => {
    return $ajax.post(`${bath.apiList}`, params).then(res => res.data)
}


/**
 * app用户管理-列表（分页）
 */
export const userList = (params) => {
    return $ajax.post(`${bath.userList}`, params).then(res => res.data)
}
/**
 * app用户管理-查看详情
 */
export const userListInfo = (params) => {
    return $ajax.get(`${bath.userListInfo}${params}`).then(res => res.data)
}
/**
 * app用户管理-删除
 */
export const userListDelete = (params) => {
    return $ajax.get(`${bath.userListDelete}?id=${params}`).then(res => res.data)
}


/**
 * 用户验证码-列表（分页）
 */
export const verifyList = (params) => {
    return $ajax.post(`${bath.verifyList}`, params).then(res => res.data)
}

/**
 * app用户管理-根据用户id查询旗下所有绑定车辆
 */
export const getBindBikeByUserId = (params) => {
    return $ajax.get(`${bath.getBindBikeByUserId}${params}`).then(res => res.data)
}


/**
 * 根据用户id查询骑行记录带轨迹（分页）
 */
export const getTrackDataByAppUserId = (params) => {
    return $ajax.post(`${bath.getTrackDataByAppUserId}`, params).then(res => res.data)
}


/**
 * 意见反馈-列表（分页）
 */
export const feedbackList = (params) => {
    return $ajax.post(`${bath.feedbackList}`, params).then(res => res.data)
}

/**
 * 意见反馈-查看详情
 */
export const feedbackTextSee = (params) => {
    return $ajax.get(`${bath.feedbackTextSee}${params}`).then(res => res.data)
}
/**
 * 意见反馈-导出
 */
export const feedbackExport = (params) => {
    return exportMethod(`${bath.feedbackExport}`, params, "意见反馈").then(res => res.data)
}

/**
 * 车辆型号-列表（分页）
 */
export const equipmentModeList = (params) => {
    return $ajax.post(`${bath.equipmentModeList}`, params).then(res => res.data)
}

/**
 * 车辆型号-根据id查询
 */
export const equipmentModeGetBelongCategoryId = (params) => {
    return $ajax.get(`${bath.equipmentModeGetBelongCategoryId}${params}`).then(res => res.data)
}

/**
 * 车辆型号-新增
 */
export const equipmentModeAdd = (params) => {
    return $ajax.post(`${bath.equipmentModeAdd}`, params).then(res => res.data)
}


/**
 * 车辆型号-查询所有
 */
export const equipmentModeListAll = (params) => {
    if (params) {
        return $ajax.get(`${bath.equipmentModeListAll}${params}`).then(res => res.data)
    } else {
        return $ajax.get(`${bath.equipmentModeListAll}`).then(res => res.data)
    }
}


/**
 * 车辆型号-删除
 */
export const equipmentModeDelete = (params) => {
    return $ajax.post(`${bath.equipmentModeDelete}`, params).then(res => res.data)
}

/**
 * 车辆型号-编辑
 */
export const equipmentModeEdit = (params) => {
    return $ajax.post(`${bath.equipmentModeEdit}`, params).then(res => res.data)
}


/**
 * 车辆列表-列表（分页）
 */
export const equipmentList = (params) => {
    return $ajax.post(`${bath.equipmentList}`, params).then(res => res.data)
}

/**
 * 车辆列表-编辑
 */
export const equipmentListCompile = (params) => {
    return $ajax.post(`${bath.equipmentListCompile}`, params).then(res => res.data)
}

/**
 * 车辆列表-根据id查询
 */
export const equipmentInfo = (params) => {
    return $ajax.post(`${bath.equipmentInfo}`, params).then(res => res.data)
}

/**
 * 车辆列表-导入车辆-新增或更新
 */
export const equipmentListAdd = (params) => {
    return $ajax.post(`${bath.equipmentListAdd}`, params).then(res => res.data)
}


/**
 * 导出车辆模板
 */
export const importDevicetemplate = (params) => {
    return exportMethod(`${bath.importDevicetemplate}`, params, "导入车辆", "xlsx").then(res => res.data);
}

/**
 * 批量更换车辆型号模板
 */
export const importMasterplate = (params) => {
    return exportMethod(`${bath.importMasterplate}`, params, "导入车辆").then(res => res.data);
}


/**
 * 车辆列表-删除
 */
export const equipmentListDelete = (params) => {
    return $ajax.post(`${bath.equipmentListDelete}`, params).then(res => res.data)
}

/**
 * 车辆列表-更换车辆其他信息
 */
export const equipmentListEdit = (params) => {
    return $ajax.post(`${bath.equipmentListEdit}`, params).then(res => res.data)
}

/**
 * 车辆列表-导出
 */
export const equipmentListExportExcel = (params) => {
    return exportMethod(`${bath.equipmentListExportExcel}`, params, "车辆列表","xlsx").then(res => res.data)
}

/**
 * 车辆列表-查询车辆的实时状态
 */
export const equipmentListGetBikeController = (params) => {
    return $ajax.post(`${bath.equipmentListGetBikeController}`, params).then(res => res.data)
}

/**
 * 车辆列表-根据批次号更新
 */
export const equipmentListUpdateByBatchId = (params) => {
    return $ajax.post(`${bath.equipmentListUpdateByBatchId}`, params).then(res => res.data)
}

/**
 * 车辆列表-批量更换
 */
export const equipmentListUpdateByBikeCode = (params) => {
    return $ajax.post(`${bath.equipmentListUpdateByBikeCode}`, params).then(res => res.data)
}

/**
 * 车辆列表-根据批次号更新-批次ID下拉框
 */
export const findAllBatchId = () => {
    return $ajax.post(`${bath.findAllBatchId}`).then(res => res.data)
}

/**
 * 车辆列表-根据批次号更新-新车辆型号下拉框
 */
export const findAllBikeTypeName = (params) => {
    if (params) {
        return $ajax.post(`${bath.findAllBikeTypeName}${params}`).then(res => res.data)
    } else {
        return $ajax.post(`${bath.findAllBikeTypeName}`).then(res => res.data)
    }

}


/**
 * 车辆列表-根据车辆编码解绑当前绑定的主用户
 */
export const unbindUserAndBike = (params) => {
    return $ajax.post(`${bath.unbindUserAndBike}`, params).then(res => res.data)
}

/**
 * 车辆列表-根据车辆编码查询绑定记录
 */
export const getBindInfoByBikeCode = (params) => {
    return $ajax.get(`${bath.getBindInfoByBikeCode}${params}`).then(res => res.data)
}

/**
 * 车辆列表-根据车辆编码更换指纹蓝牙地址
 */
export const updateFingerMac = (params) => {
    return $ajax.post(`${bath.updateFingerMac}`,params).then(res => res.data)
}

/**
 * 车辆列表-根据车辆编码查询开关锁记录
 */
export const getLockRecordByBikeCode = (params) => {
    return $ajax.get(`${bath.getLockRecordByBikeCode}${params}`).then(res => res.data)
}


/**
 * 车辆列表-根据车辆id返回数据分析结果
 */
export const getBikeDataAnalysis = (params) => {
    return $ajax.post(`${bath.getBikeDataAnalysis}`, params).then(res => res.data)
}


/**
 * 固件管理-列表（分页）
 */
export const firmwareManagementList = (params) => {
    return $ajax.post(`${bath.firmwareManagementList}`, params).then(res => res.data)
}

/**
 * 固件管理-查询所有的车辆型号（筛选）
 */
export const firmwareManagementListAllBikeType = (params) => {
    return $ajax.get(`${bath.firmwareManagementListAllBikeType}${params}`).then(res => res.data)
}

/**
 * 固件管理-查询所有的车辆类别
 */
export const firmwareManagementListAllCategory = () => {
    return $ajax.get(`${bath.firmwareManagementListAllCategory}`).then(res => res.data)
}



/**
 * 根据流水号查询导入进度
 */
export const equipmentListGetAddInfo = (params) => {
    return $ajax.get(`${bath.equipmentListGetAddInfo}?key=${params}`).then(res => res.data)
}



/**
 * 固件管理-查询所有硬件版本
 */
export const firmwareManagementListAll = (params) => {
    return $ajax.post(`${bath.firmwareManagementListAll}`, params).then(res => res.data)
}

/**
 * 固件管理-新增
 */
export const firmwareManagementAdd = (params) => {
    return $ajax.post(`${bath.firmwareManagementAdd}`, params).then(res => res.data)
}

/**
 * 固件管理-删除
 */
export const firmwareManagementDelete = (params) => {
    return $ajax.post(`${bath.firmwareManagementDelete}`, params).then(res => res.data)
}

/**
 * 固件管理-编辑
 */
export const firmwareManagementEdit = (params) => {
    return $ajax.post(`${bath.firmwareManagementEdit}`, params).then(res => res.data)
}

/**
 * 固件管理-禁用
 */
export const firmwareManagementDisable = (params) => {
    return $ajax.post(`${bath.firmwareManagementDisable}`, params).then(res => res.data)
}

/**
 * 固件管理-查询所有适配的硬件版本
 */
export const firmwareManagementListAllSuitableHwVersion = (params) => {
    return $ajax.post(`${bath.firmwareManagementListAllSuitableHwVersion}`, params).then(res => res.data)
}


/**
 * 灰度配置-查询硬件版本
 */
export const listALlDistinctHwVersion = (params) => {
    return $ajax.post(`${bath.listALlDistinctHwVersion}`, params).then(res => res.data)
}


/**
 * 固件管理-查询指定车型下所有适配的固件名称
 */
export const listAllFwVersion = (params) => {
    return $ajax.post(`${bath.listAllFwVersion}`, params).then(res => res.data)
}




/**
 * 灰度测试-任务列表（分页）
 */
export const grayScaleTestList = (params) => {
    return $ajax.post(`${bath.grayScaleTestList}`, params).then(res => res.data)
}

/**
 * 灰度测试-灰度配置
 */
export const grayScaleTestAdd = (params) => {
    return $ajax.post(`${bath.grayScaleTestAdd}`, params).then(res => res.data)
}

/**
 * 灰度测试-任务详情 根据id查询
 */
export const grayScaleTestInfo = (params) => {
    return $ajax.post(`${bath.grayScaleTestInfo}`, params).then(res => res.data)
}


/**
 * 灰度测试，取消灰度测试
 */
export const grayScaleTestCancelGrayTask = (params) => {
    return $ajax.post(`${bath.grayScaleTestCancelGrayTask}`, params).then(res => res.data)
}


/**
 * 升级任务-任务升级详情
 */
export const UpgradeListInfo = (params) => {
    return $ajax.post(`${bath.UpgradeListInfo}`, params).then(res => res.data)
}




/**
 * 正式升级任务-任务列表（分页）
 */
export const UpgradeTaskList = (params) => {
    return $ajax.post(`${bath.UpgradeTaskList}`, params).then(res => res.data)
}

/**
 * 正式升级任务-发布任务
 */
export const UpgradeTaskAdd = (params) => {
    return $ajax.post(`${bath.UpgradeTaskAdd}`, params).then(res => res.data)
}

/**
 * 正式升级任务-撤回
 */
export const UpgradeTaskDelete = (params) => {
    return $ajax.delete(`${bath.UpgradeTaskDelete}?id=${params}`).then(res => res.data)
}

/**
 * 正式升级任务-导出任务详情
 */
export const UpgradeTaskExportBluetoothTaskInfo = (params) => {
    return exportMethod(`${bath.UpgradeTaskExportBluetoothTaskInfo}`, params, '任务详情').then(res => res.data)
}


/**
 * 固件升级-恢复再次升级
 */
export const UpgradeTaskRestart = (params) => {
    return $ajax.post(`${bath.UpgradeTaskRestart}`, params).then(res => res.data)
}

/**
 * 正式升级任务-任务详情 根据id查询
 */
export const UpgradeTaskInfo = (params) => {
    return $ajax.post(`${bath.UpgradeTaskInfo}`, params).then(res => res.data)
}

/**
 * 上传app查询到的硬件信息并查询是否能升级
 */
export const UpgradeTaskRequestDeviceUpgrade = (params) => {
    return $ajax.post(`${bath.UpgradeTaskRequestDeviceUpgrade}`, params).then(res => res.data)
}



/**
 * 统计-数据统计
 */
export const getDataStatistics = () => {
    return $ajax.post(`${bath.getDataStatistics}`).then(res => res.data)
}


/**
 * 查询车辆的坐标图表
 */
export const bikeLocationData = () => {
    return $ajax.get(`${bath.bikeLocationData}`).then(res => res.data)
}


/**
 * 客户地域分布
 */
export const platformLocationData = () => {
    return $ajax.get(`${bath.platformLocationData}`).then(res => res.data)
}


/**
 * 查询平台车辆数据饼图
 */
export const platformBikeData = () => {
    return $ajax.get(`${bath.platformBikeData}`).then(res => res.data)
}


/**
 * 累计用户统计数据分析图
 */
export const getUserTotal = () => {
    return $ajax.post(`${bath.getUserTotal}`).then(res => res.data)
}

/**
 * 查询平台方的新增用户注册图表信息
 */
export const getCreateUserTotal = (params) => {
    return $ajax.get(`${bath.getCreateUserTotal}${params}`).then(res => res.data)
}


/**
 * 平台方新增用户统计信息
 */
export const appUserRegisterData = (params) => {
    return $ajax.get(`${bath.appUserRegisterData}${params}`).then(res => res.data)
}


/**
 * 骑行里程统计图
 */
export const getRidingMileage = (params) => {
    return $ajax.get(`${bath.getRidingMileage}${params}`).then(res => res.data)
}


/**
 * 骑行活跃度统计图
 */
export const getRidingActiveCycling = (params) => {
    return $ajax.get(`${bath.getRidingActiveCycling}${params}`).then(res => res.data)
}

/**
 * 查询平台方列表
 */
export const platformListAll = () => {
    return $ajax.post(`${bath.platformListAll}`).then(res => res.data)
}

/**
 * APP操作日志记录
 */
export const appLogList = (params) => {
    return $ajax.post(`${bath.appLogList}`, params).then(res => res.data)
}

/**
 * 快捷搜索-根据条件查询app接口
 */
export const queryAppRequestUrl = (params) => {
    return $ajax.get(`${bath.queryAppRequestUrl}${params}`).then(res => res.data)
}

/**
 * 在线设备列表查询
 */
export const queryList = (params) => {
    return $ajax.post(`${bath.queryList}`, params).then(res => res.data)
}

/**
 * 查看设备详情信息
 */
export const devInfo = (params) => {
    return $ajax.post(`${bath.devInfo}`, params).then(res => res.data)
}

/**
 * 下发指令
 */
export const cmdSend = (params) => {
    return $ajax.post(`${bath.cmdSend}`, params).then(res => res.data)
}

/**
 * 报文指令列表
 */
export const cmdList = (params) => {
    return $ajax.post(`${bath.cmdList}`, params).then(res => res.data)
}

/**
 * 查询电子围栏列表
 */
export const geoList = (params) => {
    return $ajax.post(`${bath.geoList}`, params).then(res => res.data)
}


/**
 * 添加电子围栏
 */
export const geoAddFence = (params) => {
    return $ajax.post(`${bath.geoAddFence}`, params).then(res => res.data)
}

/**
 *  删除电子围栏
 */
export const geoDelFence = (params) => {
    return $ajax.post(`${bath.geoDelFence}`, params).then(res => res.data)
}

/**
 *  修改电子围栏
 */
export const geoEditFence = (params) => {
    return $ajax.post(`${bath.geoEditFence}`, params).then(res => res.data)
}

/**
 *  获取车辆实时数据
 */
export const geoIotData = (params) => {
    return $ajax.post(`${bath.geoIotData}`, params).then(res => res.data)
}

/**
 *  清空车辆实时数据
 */
export const geoClearData = (params) => {
    return $ajax.post(`${bath.geoClearData}`, params).then(res => res.data)
}


/**
 *  查询在线设备列表
 */
export const iotQueryList = (params) => {
    return $ajax.post(`${bath.iotQueryList}`, params).then(res => res.data)
}


/**
 *  管理车辆-车辆列表
 */
export const listGeoInBike = (params) => {
    return $ajax.post(`${bath.listGeoInBike}`, params).then(res => res.data)
}


/**
 *  管理车辆-关联车辆
 */
export const relationBike = (params) => {
    return $ajax.post(`${bath.relationBike}`, params).then(res => res.data)
}


/**
 *  关联车辆-取消关联车辆
 */
export const disassociateBike = (params) => {
    return $ajax.post(`${bath.disassociateBike}`, params).then(res => res.data)
}


/**
 * 下载错误报告
 */
 export const getFailInfo = (params) => {
    return exportMethod(`${bath.getFailInfo}`, params, '错误报告','txt').then(res => res.data)
}

/**
 * 查询全部电子围栏列表
 */
 export const listRidingGeoFence = (params) => {
    return $ajax.post(`${bath.listRidingGeoFence}`, params).then(res => res.data)
}



/**
 *  服务网点管理-分页展示
 */
 export const networkList = (params) => {
    return $ajax.post(`${bath.networkList}`, params).then(res => res.data)
}


/**
 *  新增服务网点
 */
 export const networkAdd = (params) => {
    return $ajax.post(`${bath.networkAdd}`, params).then(res => res.data)
}

/**
 *  编辑服务网点
 */
 export const networkEdit = (params) => {
    return $ajax.post(`${bath.networkEdit}`, params).then(res => res.data)
}


/**
 * 删除服务网点
 */
 export const networkDelete = (params) => {
    return $ajax.post(`${bath.networkDelete}`, params).then(res => res.data)
}

/**
 * 查询SIM卡列表
 */
 export const simcardList = (params) => {
    return $ajax.post(`${bath.simcardList}`, params).then(res => res.data)
}

/**
 * SIM卡摘要信息
 */
 export const summaryInfo = (params) => {
    return $ajax.post(`${bath.summaryInfo}`, params).then(res => res.data)
}

/**
 * 刷新用户信息
 */
export const userRefresh = (params) => {
    return $ajax.post(`${bath.userRefresh}`, params).then(res => res.data)
}


//通讯协议列表
export const protocolList = () => {
    return $ajax.post(`${bath.protocolList}`).then(res => res.data)
}

//新增通讯协议
export const protocolEdit = (params) => {
    return $ajax.post(`${bath.protocolEdit}`,params).then(res => res.data)
}

//删除通讯协议
export const protocolDelete = (params) => {
    return $ajax.post(`${bath.protocolDelete}`,params).then(res => res.data)
}

//获取错误代码列表
export const codeList = (params) => {
    return $ajax.post(`${bath.codeList}`,params).then(res => res.data)
}

//错误代码编辑
export const errCodeEdit = (params) => {
    return $ajax.post(`${bath.errCodeEdit}`,params).then(res => res.data)
}

//删除错误代码
export const errCodeDelete = (params) => {
    return $ajax.post(`${bath.errCodeDelete}`,params).then(res => res.data)
}

//给请求添加一个请求拦截器
$ajax.interceptors.request.use(function (config) {
    let token = localStorage.getItem('token');
    let platformData = JSON.parse(localStorage.getItem('platformData'));
    if (token) {
        config.headers.common['Authorization'] = token;
    }
    if (platformData) {
        if (platformData.region == 'cn') {
            config.headers.common['Accept-Language'] = 'zh-CN';
        }
        if (platformData.region == 'jp') {
            config.headers.common['Accept-Language'] = 'ja-Jp';
        }
        if (platformData.region == 'eur') {
            config.headers.common['Accept-Language'] = 'en-US';
        }
        if (platformData.region == 'usa') {
            config.headers.common['Accept-Language'] = 'en-US';
        }
        config.headers.common['appCode'] = platformData.appCode;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// 添加响应拦截器
$ajax.interceptors.response.use(function (response) {
    if (response.status == 500 || response.status == 503) {
        ElementUI.Message.error(i18n.t('config.text12'));
        return response;
    }
    // 对响应数据做点什么
    if (response.data.code == 0) {
        return response;
    }
    // 对响应数据做点什么
    if (response.data.code == 5600) {
        ElementUI.Message.closeAll()
        ElementUI.Message.error(i18n.t('config.text13'));
    } else if (response.data.code == 6900) {
        ElementUI.Message.closeAll()
        ElementUI.Message.error(i18n.t('config.text12'));
    } else if (response.data.code == 5800) {
        ElementUI.Message.closeAll()
        ElementUI.Message.error(i18n.t('config.text14'));
        setTimeout(() => {
            window.location.href = window.location.origin + '/#/login';
            sessionStorage.clear();
            localStorage.clear();
        }, 1000);
    } else {
        ElementUI.Message.error(response.data.msg);
    }
    return Promise.reject(response.data);
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});



//给请求添加一个请求拦截器
loginAxios.interceptors.request.use(function (config) {
    let platformData = JSON.parse(localStorage.getItem('platformData'));
    if (config.url == '/api/dilu-admin/system/login') {
        config.headers.belongCustomer = platformData.id
    }
    if (platformData) {
        if (platformData.region == 'cn') {
            config.headers.common['Accept-Language'] = 'zh-CN';
        }
        if (platformData.region == 'jp') {
            config.headers.common['Accept-Language'] = 'ja-Jp';
        }
        if (platformData.region == 'eur') {
            config.headers.common['Accept-Language'] = 'en-US';
        }
        if (platformData.region == 'usa') {
            config.headers.common['Accept-Language'] = 'en-US';
        }
        config.headers.common['appCode'] = platformData.appCode;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
loginAxios.interceptors.response.use(function (response) {
    if (response.status == 500 || response.status == 503) {
        ElementUI.Message.error(i18n.t('config.text12'));
        return response;
    }
    // 对响应数据做点什么
    if (response.data.code == 0) {
        return response;
    } else if (response.data.code == 5705) {
        ElementUI.Message.error(i18n.t('config.text15'));
        return response;
    }
    return Promise.reject(response.data);
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

//导出
function exportMethod(url,params,name,suffix) {
    let str = '?'
    for (let i in params) {
        if (params[i] != '' && params[i] != null) {
            str += i + '=' + params[i] + '&'
        }
    }
    if (!params) {
        str = ''
    }
    return axios({
        method: 'get',
        url: url + str,
        headers: {
            Authorization: localStorage.getItem('token'),
        },
        responseType: 'blob'
    }).then(res => {
        if (!res) {
            ElementUI.Message.error(i18n.t('config.text16'));
            return
        }
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `${name}.${suffix?suffix:'xls'}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).catch(() => {
        ElementUI.Message.error(i18n.t('config.text16'));
    })
}

//导出二维码
function exportQrcodeMethod(url, name) {
    return axios({
        method: 'get',
        url: url,
        responseType: 'blob'
    }).then(res => {
        if (!res) {
            ElementUI.Message.error(i18n.t('config.text16'));
            return
        }
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `${name}.png`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).catch(() => {
        ElementUI.Message.error(i18n.t('config.text16'));
    })
}